import { render, staticRenderFns } from "./settingsTemplateConfig.vue?vue&type=template&id=0c976f74&scoped=true"
import script from "./settingsTemplateConfig.vue?vue&type=script&lang=js"
export * from "./settingsTemplateConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c976f74",
  null
  
)

export default component.exports